import { addToast, ErrorToast, Toastß } from '@otter-ai/den-components';

export function displaySuccessToast(description: string) {
  addToast(
    <Toastß description={description} altText={description} showCloseIcon />,
  );
}

export function displayErrorToast(description: string) {
  addToast(
    <ErrorToast
      description={description}
      descriptionContainerClassName="text-sm font-semibold flex justify-center items-center"
    />,
  );
}
